import './Resources.scss'

import * as lottie_informatica from '../../lotties/Resources/informatica.json'
import * as lottie_intercozy from '../../lotties/Resources/intercozy.json'
import * as lottie_languages from '../../lotties/Resources/languages.json'
import * as lottie_library from '../../lotties/Resources/library.json'

import Lottie from 'react-lottie'
import { animated } from 'react-spring'
import VisibilitySensor from 'react-visibility-sensor'
import AddressBookComp from '../../components/AddressBook/AddressBook'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import Desplegable from '../../components/Desplegable/Desplegable'
import DidYouKnow from '../../components/DidYouKnow/DidYouKnow'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import Briefcase from '../../components/Icons/Briefcase'
import Bulb from '../../components/Icons/Bulb'
import Diplom from '../../components/Icons/Diplom'
import Earth from '../../components/Icons/Earth'
import File from '../../components/Icons/File'
import Football from '../../components/Icons/Football'
import Microscope from '../../components/Icons/Microscope'
import Plane from '../../components/Icons/Plane'
import RobotArm from '../../components/Icons/RobotArm'
import SparkleLight from '../../components/Icons/SparkleLight'
import Star from '../../components/Icons/Star'
import Kites from '../../components/Kites/Kites'
import ListItem from '../../components/ListItem/ListItem'
import { contacts } from '../../data'

const Resources = ({ color = 'red', secondary = 'light-blue', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties
  const lottieLibrary = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_library.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )
  const lottieLanguages = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_languages.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )
  const lottieIntercozy = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_intercozy.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )
  const lottieInformatica = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_informatica.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Desplegables area
  const socioeconomic = (
    <div className="desplegable-container socioeconomic">
      <p>
        La convocatoria de ayudas socioeconómicas está en <b>constante revisión y ampliación</b> para adaptarse a las circunstancias del momento, por lo que{' '}
        <b>es importante que la consultes con frecuencia</b>:
      </p>

      <VisibilitySensor partialVisibility minTopValue={50}>
        {({ isVisible }) => (
          <div className={`animated-visibility ${isVisible ? 'show-visible' : 'hidden-visible'}`}>
            <div className="romb-container">
              <div className="numbered-romb">
                <img src="/svg/front-pages/resources/numbered-rombs/first.svg" alt="" />
              </div>
            </div>
            <div className={`box ${secondary} fat`}>
              <p className="text-semi-normal bold">Ayudas con cargo al Fondo Social de estudiantes UAM</p>
            </div>
            <p className="text-normal text-subnormal">
              Estas ayudas están orientadas a <b>cubrir los costes de matrícula</b> de estudiantes de títulos oficiales en situaciones desfavorables
            </p>
          </div>
        )}
      </VisibilitySensor>

      <VisibilitySensor partialVisibility minTopValue={50}>
        {({ isVisible }) => (
          <div className={`animated-visibility ${isVisible ? 'show-visible' : 'hidden-visible'}`}>
            <div className="romb-container">
              <div className="numbered-romb">
                <img src="/svg/front-pages/resources/numbered-rombs/second.svg" alt="" />
              </div>
            </div>
            <div className={`box ${secondary} fat`}>
              <p className="text-semi-normal bold">Ayudas para atención psicológica en el Centro de Psicología Aplicada de la UAM</p>
            </div>
            <p className="text-normal text-subnormal">
              Para estudiantes que <b>no pueden acceder al servicio</b> por motivos económicos.
            </p>
          </div>
        )}
      </VisibilitySensor>

      <VisibilitySensor partialVisibility minTopValue={50}>
        {({ isVisible }) => (
          <div className={`animated-visibility ${isVisible ? 'show-visible' : 'hidden-visible'}`}>
            <div className="romb-container">
              <div className="numbered-romb">
                <img src="/svg/front-pages/resources/numbered-rombs/third.svg" alt="" />
              </div>
            </div>
            <div className={`box ${secondary} fat`}>
              <p className="text-semi-normal bold">Ayudas de estudios a estudiantes con proteccion internacional, temporal y/o solicitantes de asilo</p>
            </div>
            <p className="text-normal text-subnormal">
              Para estudiantes matriculados/as en la UAM que estando en posesión del estatus de <b>refugiado o de petición de asilo, necesiten de apoyo</b> para
              la continuidad o inicio de estudios.
            </p>
          </div>
        )}
      </VisibilitySensor>

      <VisibilitySensor partialVisibility minTopValue={50}>
        {({ isVisible }) => (
          <div className={`animated-visibility ${isVisible ? 'show-visible' : 'hidden-visible'}`}>
            <div className="romb-container">
              <div className="numbered-romb">
                <img src="/svg/front-pages/resources/numbered-rombs/forth.svg" alt="" />
              </div>
            </div>
            <div className={`box ${secondary} fat`}>
              <p className="text-semi-normal bold">Préstamo de material informático</p>
            </div>
            <p className="text-normal text-subnormal">
              Esta convocatoria de ayudas está orientada a <b>facilitar los recursos informáticos y de conexión a internet</b> que los estudiantes puedan
              necesitar para mantener el desempeño académico adecuado cuando <b>no disponen de medios propios por causas económicas.</b>
            </p>
          </div>
        )}
      </VisibilitySensor>
    </div>
  )

  const grade = (
    <div className="desplegable-container grade questions-container-list">
      <div className="youth-container">
        <div className={`youth-block ${color}`}>
          <div className="icon-container">
            <Star />
          </div>
          <ListItem color={secondary}>
            <h5 className="text-semi-normal heroic italic uppercase">Premios UAM Talento Joven</h5>
            <p className="text-normal text-subnormal">
              Supone la <b>exención de las tasas de matrícula</b>. Este programa cuenta con diferentes convocatorias orientadas a premiar tanto el rendimiento
              como el esfuerzo personal en situaciones adversas al estudio.
            </p>
          </ListItem>
        </div>
      </div>
      <div className={`separator-programs ${color}`} />
      <div className={`enterpreneur-container ${color}`}>
        <div className={`enterpreneur-block ${color}`}>
          <div className="icon-container">
            <SparkleLight />
          </div>
          <ListItem color={secondary}>
            <h5 className="text-semi-normal heroic italic uppercase">Programa UAM Talento Emprendedor</h5>
            <p className="text-normal text-subnormal">
              La UAM también concede premios para apoyar a los nuevos estudiantes que presenten <b>proyectos innovadores y de alto valor social</b>. Si obtienes
              uno de los premios te asignaremos un <b>mentor profesional</b> para desarrollar tu proyecto y tendrás acceso gratuito al{' '}
              <b>Curso de Emprendimiento Digital UAM Emprende</b>. Puedes consultar toda la información en{' '}
            </p>
          </ListItem>
        </div>

        <ExternalLink secondary={color} color={secondary} url="https://uamemprende.es/" text="https://uamemprende.es/" />

        <AddressBookComp color={color} data={contacts['uam-emprende']} />
      </div>
    </div>
  )

  const internalization = (
    <div className="desplegable-container internalization new-system-list questions-container-list">
      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Plane />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Ayudas para movilidad</h5>
          <p className="text-normal text-subnormal">
            Para realizar estudios en instituciones <b>fuera de la UE</b> con las que la UAM tenga convenio.
          </p>
        </ListItem>
      </div>

      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Earth />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Ayudas para actividades de internacionalización</h5>
          <p className="text-normal text-subnormal">
            Para estudiantes que realicen actividades que contribuyan a la <b>internacionalización</b> de la UAM.
          </p>
        </ListItem>
      </div>
    </div>
  )

  const other = (
    <div className="desplegable-container internalization new-system-list questions-container-list">
      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Star color={color} />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Becas de excelencia</h5>
          <p className="text-normal text-subnormal">
            Para estudiantes de <b>Máster Oficial</b>
          </p>
        </ListItem>
      </div>

      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Microscope color={color} />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Ayudas económicas</h5>
          <p className="text-normal text-subnormal">
            Para actividades del <b>estudiantado</b>
          </p>
        </ListItem>
      </div>

      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Briefcase color={color} />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Ayudas económicas</h5>
          <p className="text-normal text-subnormal">
            Para la realización de <b>prácticas externas curriculares</b> en Departamentos, Servicios o Unidades de la UAM
          </p>
        </ListItem>
      </div>

      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <RobotArm color={color} />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Premios</h5>
          <p className="text-normal text-subnormal">
            Premios a los mejores <b>trabajos de fin de Máster y Grado</b> basados en el Portal de Datos Abiertos de la UAM
          </p>
        </ListItem>
      </div>

      <div className={`item-block ${color}`}>
        <div className="icon-container">
          <Football color={color} />
        </div>
        <ListItem color={secondary}>
          <h5 className="text-semi-normal heroic italic uppercase">Convocatoria de ayudas</h5>
          <p className="text-normal text-subnormal">
            Al estudiantado <b>deportista</b> de la UAM
          </p>
        </ListItem>
      </div>
    </div>
  )

  const lendings = (
    <div className="desplegable-container lendings">
      <p>
        La Biblioteca cuenta con <b>máquinas de autopréstamo</b> y buzones de <b>devolución de libros</b>, podrás encontrarlos en el vestíbulo de las Facultades
        o de la Escuela Politécnica Superior.
      </p>
      <p>
        Los libros que tengas en préstamo se <b>renovarán automáticamente hasta 5 veces</b>, siempre y cuando no los solicite otra persona. Si compruebas que
        necesitas un libro que está prestado, Accede a nuestro catálogo a través de la página web de la biblioteca:
      </p>

      <ExternalLink url={'https://www.uam.es/uam/vida-universitaria/bibliotecas'} color={secondary} secondary={color} />

      <p>
        En nuestro catálogo <b>Bun!</b> Buscador único podrás realizar <b>reservas</b> de libros, acceder al <b>contenido electrónico</b>, consultar la
        <b>bibliografía recomendada</b> de una asignatura, etc.
      </p>
      <p>A través de la web de la biblioteca puedes reservar libros o renovar los préstamos:</p>

      <ExternalLink url="https://www.uam.es/uam/vida-universitaria/bibliotecas" color={secondary} secondary={color} text="¡Visita nuestra web!" />

      <p>
        Recuerda consultar <b>posibles cambios</b> en cuanto a horarios y accesos en periodos de exámenes.
      </p>
    </div>
  )

  const opening_times = (
    <div className="desplegable-container opening_times">
      <p>
        El horario habitual de las bibliotecas UAM es de <b>9 a 20,30 horas</b>, salvo la de <b>Medicina, que abre de 8 a 20 horas</b>.
      </p>
    </div>
  )

  const workRooms = (
    <div className="desplegable-container work-rooms">
      <p>
        Son espacios adaptados para el estudio, la investigación y el <b>trabajo en equipo</b> con acceso a herramientas tecnológicas. Tienes más información
        en:
      </p>
      <ExternalLink color={secondary} secondary={color} url="https://biblioguias.uam.es/salas_trabajo/inicio" text="Más info aquí" />
      <p>
        Puedes ver las salas de trabajo disponibles en cada biblioteca y reservarlas en la <a href="https://biblioagenda.uam.es/">Biblioagenda</a>, donde además
        encontrarás <b>eventos</b> y <b>cursos de formación</b> que ofrece la Biblioteca.
      </p>
    </div>
  )

  const owl = (
    <div className="desplegable-container owl">
      <p>
        En la Biblioteca de Ciencias hay una sala de estudio que está disponible durante gran parte del curso, especialmente en periodos de exámenes, con
        horarios extendidos <b>(hasta la 1:00 y fines de semana)</b>.
      </p>
      <ExternalLink color={secondary} secondary={color} url="https://biblioguias.uam.es/sala_buho/inicio" text="Consulta los horarios" />
    </div>
  )

  const matricula = (
    <div className="desplegable-container matricula">
      <div className="center-icon">
        <File width={40} />
      </div>
      <p>
        La oferta de cursos del Servicio de Idiomas es amplia y permite adquirir conocimientos lingüísticos en{' '}
        <i>alemán, español como lengua extranjera, francés, inglés e italiano</i>.
      </p>
      <p>
        Los cursos de carácter anual, cuatrimestral o intensivo se imparten en el <b>pabellón A</b>, situado al lado de la estación de <b>RENFE</b>.
      </p>
      <p>
        Algunos cursos se ofrecen también en <b>remoto o en híbrido</b>, para los estudiantes que prefieren la flexibilidad que ofrecen estas modalidadades.
      </p>
      <p>
        Para participar en los cursos deberás realizar una <b>prueba de nivel</b> y después proceder a <b>automatricularte</b> siguiendo las instrucciones de la
        página web.
      </p>
      <p>
        <b>Presta atención a los plazos</b>, ya que algunos son cursos con mucha demanda.
      </p>
      <DidYouKnow color={secondary}>
        <p>
          Si tienes poco tiempo durante el curso académico, aprovecha el mes de <b>junio</b> para lograr tus objetivos.
        </p>
        <p>
          El Servicio de Idiomas te ofrece alternativas flexibles y adaptada a tus necesidades: <b>talleres y cursos intensivos</b> con enfoques específicos:
          Erasmus, conversación, etc.
        </p>
        <p>
          <b>Puedes elegir la combinación</b> que mejor se adapte a tu perfil y poder así obtener <b>hasta 9 créditos</b> por la superación de cursos de
          idiomas.
        </p>
        <p>Consúltalo con la secretaría de tu facultad.</p>
      </DidYouKnow>
    </div>
  )

  const titles = (
    <div className="desplegable-container titles">
      <div className="center-icon">
        <Diplom />
      </div>
      <p>
        Por otro lado, el Servicio de Idiomas también realiza <b>exámenes oficiales</b> para la obtención de certificados. Podrás acreditar los niveles{' '}
        <b>B1, B2, C1 y C2</b> de Inglés a través de la prueba multinivel <b>Linguaskill</b> desarrollada por <b>Cambridge</b>. Además, a través del propio
        Servicio, podrás examinarte del nivel B1 en <b>Alemán</b>, y de los niveles B1 y B2 en <b>Francés e Italiano</b>.
      </p>
      <p>
        Con el objetivo de que puedas familiarizarte con el modelo de evaluación, podrás apuntarte a los <b>talleres de estrategias</b> para la realización de
        los <b>exámenes de certificación</b> en <i>todos los idiomas</i>.
      </p>
    </div>
  )

  const interchange = (
    <div className="desplegable-container interchange">
      <p>
        La UAM tiene un elevado número de <b>acuerdos internacionales</b> con las mejores universidades del mundo para la movilidad académica de los
        estudiantes. Vive una experiencia que te enriquecerá a nivel académico y personal, adquiriendo nuevas capacidades y habilidades que te permitirían a ser
        más competitivo de cara a tu futuro laboral, mejorando tu currículum.
      </p>

      <Kites />

      <p>
        Los programas de movilidad te permitirán realizar una <b>estancia de estudios</b> en instituciones de educación superior de <b>España</b> o de un{' '}
        <b>gran número de países del mundo</b>, matricularte en universidades con las que la UAM tiene firmados convenios y que los estudios que realices allí
        te sean reconocidos a tu regreso a la Autónoma. Gracias a estos programas de intercambio, podrás internacionalizar tus estudios durante{' '}
        <b>un año académico o un cuatrimestre</b> participando en el Programa <b>Erasmus+</b>, el Programa de Movilidad de Convenios Internacionales, el{' '}
        <b>SEMP</b> u otros. También puedes realizar una movilidad en España con el Programa <b>SICUE</b> (Sistema de Intercambio entre Centros Universitarios
        Españoles).
      </p>

      <DidYouKnow color={secondary}>
        <p>
          A lo largo de tus estudios podrás realizar <b>más de una movilidad.</b>
        </p>
      </DidYouKnow>

      <p>
        Otra posibilidad será la de cursar una <b>Doble o Múltiple Titulación Internacional</b> por la que, además del título que curses en la UAM, podrás
        obtener otro título de una universidad extranjera.
      </p>
      <p>
        También puedes cursar un <b>Título Conjunto Internacional</b> como los programas <b>Erasmus Mundus.</b>
      </p>
      <p>
        Y, por supuesto, no olvides la posibilidad de participar en alguna modalidad de estudios en alguna de nuestras universidades de la Red <b>CIVIS</b>,
        cursos de corta duración, <b>CIVIS Students Info Days o movilidad virtual CIVIS.</b>
      </p>

      <DidYouKnow color={secondary}>
        <p>
          La UAM forma parte de <b>CIVIS</b>, la iniciativa europea que une a once universidades líderes del continente para formar un{' '}
          <b>espacio común de educación superior</b> en el que los miembros de la comunidad universitaria podrán desarrollar sus estudios y carreras, generar
          colaboraciones y beneficiarse de recursos compartidos como si estuviesen en su propia universidad. Si quieres conocer más detalles sobre el proyecto,
          visita{' '}
          <a href="https://civis.uam.es/" target="_blank" rel="noopener noreferrer" className="bold">
            civis.uam.es
          </a>
        </p>
      </DidYouKnow>

      <p>
        Por otra parte, a través del Programa de Prácticas internacional, podrás realizar <b>prácticas en empresas o instituciones internacionales</b> y
        reconocer los créditos correspondientes o como <b>prácticas extracurriculares.</b>
      </p>

      <DidYouKnow color={color} title={<Bulb color={'white'} />}>
        <p>En la secciónde Voluntariado descubrirás otras opciones diferentes de movilidad.</p>
      </DidYouKnow>
    </div>
  )

  const requirements = (
    <div className="desplegable-container requirements">
      <p>
        Para poder participar en estos programas de movilidad de estudios o prácticas necesitas haber <b>superado 60 ECTS</b> y contar con un nivel de{' '}
        <b>conocimiento de idiomas adecuado</b>, acreditado con algún <b>certificado oficial.</b> Consulta las opciones que ofrece nuestro Servicio de Idiomas.
      </p>
      <p>
        Además, contamos con varios programas de <b>becas</b> o ayudas financieras para ayudarte a <b>cubrir la totalidad o parte de los gastos</b> de estas
        estancias.
      </p>
      <p>
        Pásate por el Servicio de Relaciones Internacionales y Movilidad (la oficina central está en el edificio Plaza Mayor) o por la Oficina de Relaciones
        Internacionales de tu centro y te informarán de los requisitos y las fechas en que se puede formalizar tu solicitud.
      </p>
      <p>Más información:</p>

      <ExternalLink url="https://www.uam.es/uam/internacional/movilidad-estudiantes" color={secondary} secondary={color} text="Más información" />
    </div>
  )

  const intercozy = (
    <div className="desplegable-container intercozy">
      <p>
        Si eres estudiante internacional y necesitas <b>ayuda</b> con los <b>trámites de visados, permisos de residencia y trabajo</b> o si quieres que se te
        asigne un Buddy (estudiante local que te ayude con tu incorporación a la UAM y a Madrid) pásate por la Oficina de Acogida Internacional (OAI) que se
        encuentra en el Servicio de Relaciones Internacionales (SERIM) en la Plaza Mayor del campus de Cantoblanco.
      </p>
      {lottieIntercozy}
    </div>
  )

  const contest = (
    <div className="desplegable-container contest">
      <p>
        Para apoyar la campaña de encuestas, cada año se organiza un <b>concurso de carteles</b> abierto a toda la comunidad.{' '}
        <b>¿Te atreves a presentar una idea?</b>
      </p>
      <p>
        Diseña un cartel para promover la participación en las encuestas de actividad docente del <b>curso 2024-2025.</b>
      </p>
      <p>
        Puedes participar si eres <b>estudiante, AlumniUAM, PDI, PDIF, o PTGAS de la UAM</b>, sus centros adscritos o de la FUAM. Consigue un{' '}
        <b>premio de 900€</b> o uno de los <b>8 premios de 200€</b> que se reparten entre los participantes. <b>A finales de septiembre</b> suelen publicarse en
        las redes sociales UAM las <b>bases del concurso.</b> Tendrás varias semanas para elaborar una propuesta y los carteles ganadores se conocerán poco
        tiempo después.
      </p>
      <p className={`colored ${secondary} uppercase urbana text-medium`}>Be the next winner!</p>
      <div className="contest-container">
        <img src="/svg/front-pages/who-can-help/cartel_encuestas_2026.png" alt="Cartel de encuestas 2026" />
        <ExternalLink
          text={'Más info sobre encuestas de evaluación docente'}
          url={'https://www.uam.es/uam/en/uce/encuestas-actividad-docente'}
          color={secondary}
          secondary={color}
        />
      </div>
    </div>
  )

  // Modals area
  const helps = (
    <ModalContainer secondary={secondary} color={color} title="Becas, ayudas y premios" onClick={() => closeModal()}>
      <p>Durante tus estudios puedes beneficiarte de ayudas, becas y premios de muy diversos tipos.</p>
      <p>
        Además de las <b>becas y subvenciones generales</b> (por ejemplo, las becas del Ministerio de Educación, las becas de colaboración, las becas
        autonómicas, los premios nacionales para estudiantes universitarios, los programas ERASMUS, SEMP, Becas Santander Progreso, etc.), la UAM tiene un{' '}
        <b>programa propio de becas, ayudas y premios.</b>
      </p>

      <div className="questions-container-list">
        <Desplegable forceHiding secondary={secondary} color={color} title="Ayudas socioeconómicas">
          {socioeconomic}
        </Desplegable>
      </div>

      <p>
        <b>Además,</b> existen otras muchas ayudas propias de la UAM, entre las que destacamos:
      </p>
      <div className="questions-container-list">
        <Desplegable forceHiding secondary={secondary} color={color} title="Ayudas y premios para estudiantes de grado">
          {grade}
        </Desplegable>
        <Desplegable forceHiding secondary={secondary} color={color} title="Ayudas propias de la UAM para la internacionalización del estudiantado">
          {internalization}
        </Desplegable>
        <Desplegable forceHiding secondary={secondary} color={color} title="Otras ayudas">
          {other}
        </Desplegable>
      </div>
      <p>En el documento de cada convocatoria encontrarás los requisitos de solicitud y los plazos para hacerlo, toda la información está disponible en</p>
      <ExternalLink url="https://www.uam.es/uam/estudios/becas-ayudas" color={secondary} secondary={color} />
      <p>
        En todos los casos es muy importante que conozcas bien las <b>convocatorias, sus requisitos y plazos</b>. La Sección de Becas y Ayudas te ofrecerá
        información sobre algunas de ellas, además de ayudarte a gestionar las de otras entidades (becas generales MEC y las mencionadas al inicio de esta
        página).
      </p>
      <p>
        Ante cualquier otra duda relacionada con ayudas que no sean gestionadas por la Sección, en <b>UAM Estudiantes</b> podremos darte la información
        necesaria.
      </p>
      <AddressBookComp color={color} data={contacts['becas-y-ayudas']} />
    </ModalContainer>
  )

  const libraries = (
    <ModalContainer secondary={secondary} color={color} title="Bibliotecas" onClick={() => closeModal()}>
      {lottieLibrary}

      <p>
        Las bibliotecas de la UAM son excelentes y debes tenerlas como punto de referencia a lo largo de tus estudios: en ellas no solo encontrarás{' '}
        <b>libros y revistas</b>, sino también <b>material técnico de todo tipo</b>.
      </p>
      <p>
        Cada centro dispone de su <b>propia biblioteca</b> dentro del edificio, excepto las Bibliotecas de Humanidades y Ciencias, que cuentan con edificios
        propios.
      </p>
      <p>
        Puedes acceder a cualquiera de ellas para <b>consultar sus fondos, estudiar, tomar en préstamo</b> un ordenador portátil, <b>reservar</b> una sala de
        trabajo en grupo o apuntarse a los cursos de formación para aprender a gestionar la información y los recursos bibliográficos. Muchos de los servicios
        requieren que hagas uso del <b>carné universitario</b>, disponible en formato digital en la app UAM.
      </p>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Préstamos">
          {lendings}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Horarios">
          {opening_times}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Salas de trabajo">
          {workRooms}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Sala de estudio 24 horas (búho)">
          {owl}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const languages = (
    <ModalContainer secondary={secondary} color={color} title="Idiomas" onClick={() => closeModal()}>
      {lottieLanguages}

      <p>
        ¿Sabías que la Universidad apoya la <b>formación continua</b> en idiomas como parte del crecimiento personal?
      </p>
      <p>
        Si te interesa desarrollar tus <b>competencias lingüísticas</b>, aprovecha tu paso por la UAM para iniciar, afianzar y acreditar tu conocimiento de
        idiomas: algunos Grados lo requieren para conseguir el título y es necesario para algunas <b>becas de movilidad, posgrado, plazas y oposiciones.</b> En
        cualquier caso, aumentará tus oportunidades para acceder al <b>mundo profesional</b> o continuar tu <b>formación académica.</b>
      </p>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Cursos">
          {matricula}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Títulos">
          {titles}
        </Desplegable>
      </div>

      <ExternalLink
        color={color}
        secondary={secondary}
        url="https://www.uam.es/uam/servicio-idiomas"
        text="Clica para apuntarte a los cursos de idiomas o para realizar exámenes de certificación"
      />
      <AddressBookComp color={color} data={contacts['idiomas']} />
    </ModalContainer>
  )

  const movility = (
    <ModalContainer secondary={secondary} color={color} title="Movilidad internacional y nacional" onClick={() => closeModal()}>
      <p>
        ¿Te gustaría irte de <b>Erasmus</b> por Europa u otros países asociados? ¿Quieres estudiar parte de tu carrera en una universidad de{' '}
        <b>otro continente</b>? ¿o quizá prefieras hacerlo en <b>otra universidad española</b>? ¿te interesaría hacer prácticas en el <b>extranjero</b>?
      </p>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Programas de intercambio">
          {interchange}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Requisitos">
          {requirements}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Acogida internacional">
          {intercozy}
        </Desplegable>
      </div>
      <AddressBookComp color={color} data={contacts['relaciones-internacionales']} />
    </ModalContainer>
  )

  const technology = (
    <ModalContainer secondary={secondary} color={color} title="Aulas de informática" onClick={() => closeModal()}>
      {lottieInformatica}
      <p>
        Es una <b>red de aulas</b> distribuidas por los centros a las que puedes acudir si necesitas usar un <b>ordenador</b> (recuerda que también existe
        préstamo de portátiles en las bibliotecas).
      </p>
      <p>
        Si necesitas <b>imprimir o escanear documentos</b>, puedes utilizar las impresoras <b>disponibles en estas aulas.</b>
      </p>
    </ModalContainer>
  )

  const surveys = (
    <ModalContainer secondary={secondary} color={color} title="Encuestas de evaluación docente" onClick={() => closeModal()}>
      <p>
        Al final de cada semestre se hacen <b>encuestas online para evaluar la calidad de la docencia</b> (titulación, asignaturas y profesorado). Es una manera
        muy adecuada de contribuir a la mejora continua de la experiencia UAM. #TuVozUAM es imprescindible para para seguir mejorando los planes de estudio.
      </p>

      <div className="your-voice">
        <img src="/svg/front-pages/who-can-help/tu-voz-uam.svg" alt="" />
      </div>

      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Concurso para apoyar la campaña de encuestas">
          {contest}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const items = [
    { key: 'helps', content: helps, title: 'Becas, ayudas y premios' },
    { key: 'libraries', content: libraries, title: 'Bibliotecas' },
    { key: 'languages', content: languages, title: 'Idiomas' },
    { key: 'movility', content: movility, title: 'Movilidad internacional y nacional' },
    { key: 'technology', content: technology, title: 'Aulas de informática' },
    { key: 'surveys', content: surveys, title: 'Encuestas de evaluación docente' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/Resources_logo_back.svg" alt="" />
      </div>
      <div className="logo-front">
        <img src="/splash/svg/Resources_logo_front.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/Resources_logo_main.svg" className="illustration" alt="" />
        <img src="/splash/png/Resources.png" className="image" alt="" />
      </animated.div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'Resources'}
      title={'Aprovecha los recursos de la UAM'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default Resources
